module.exports = __webpack_public_path__ + "img/totalRevenueBlack.7335944c.png";